import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./ObservadorFormulari.module.css";
import ObservadorFormulariFoto from "./ObservadorFormulariFoto";
import { Select, Switch, Input, DatePicker, Avatar, Tree, Icon } from "antd";
import { modificarValorBooleanPerTextSiNo } from "../commons/TaulaOrdenacioCerca";
import PopOverError from "../commons/PopOverError";
import {
  observadorIntroduccioModificarCamp,
  setTitolApartat
} from "../../actions";
import {
  getMunicipis,
  getDadesEditades,
  getDadesOriginals,
  getRols,
  getMostrarErrors,
  getIndretsIndividusFenofasesObservador
} from "../../reducers";
import {
  TEXT_QUAN_NO_HI_HA_DADA,
  TITOL_CREAR_OBSERVADOR,
  TITOL_EDITAR_OBSERVADOR,
  TITOL_DADES_OBSERVADOR,
  OBSERVADOR_EXPERT_VALOR_DEFECTE,
  OBSERVADOR_ACTIU_VALOR_DEFECTE,
  OBSERVADOR_PERMIS_MOSTRAR_NOM_VALOR_DEFECTE
} from "../../constantsFormularis";

import VariableLlista from "../commons/variableLlista";
import {
  MASCARA_DDMMYYYY,
  MASCARA_YYYYMMDD,
  convertirTextAMomentUTC
} from "../../utils/dates";
import { obtenirErrorsDadesObservador } from "../../utils/formularis";

const nomCampNumeroCarrer = "numero";
const nomCampPis = "pis";
const nomCampPorta = "porta";
const nomCampNomComarca = "comarca";
const nomCampNomMunicipi = "municipi";
const nomCampMunicipi = "codiINE";
const nomCampExpert = "expert";
const nomCampPermis = "permisMostrarNom";
const nomCampActiu = "usuariActiu";
const nomCampUsuariRol = "usuariRol";
const nomCampNomObservador = "nom";
const nomCampCognom1Observador = "cognom1";
const nomCampCognom2Observador = "cognom2";
const nomCampTelefon = "telefon";
const nomCampEmail = "usuariCorreuElectronic";
const nomCampCarrer = "carrer";
const nomCampCodiPostal = "codiPostal";
const nomCampUsuariNom = "usuariNom";
const nomCampDataAlta = "dataAlta";
const nomCampDataBaixa = "dataBaixa";
const nomCampMotiuBaixa = "motiuBaixa";

const renderitzarError = errorCamp => {
  if (errorCamp) {
    return <PopOverError contingut={errorCamp} classNameIcona="icona-error" />;
  }
  // és necessari retornar un div buit i no null perquè cssGrid ho interpreti com a contingut
  return <div />;
};

const renderitzarCampTipusText = (
  nomCamp,
  esEditable,
  valor,
  observadorIntroduccioModificarCamp
) => {
  if (!esEditable) {
    // si hi ha valor, sempre es passa a string perquè així ens assegurem que si és una variable booleana aparegui
    return valor ? valor.toString() : TEXT_QUAN_NO_HI_HA_DADA;
  }

  return (
    <Input
      aria-labelledby={nomCamp}
      defaultValue={valor}
      onBlur={event => {
        const valor = event.target.value;
        observadorIntroduccioModificarCamp(nomCamp, valor ? valor : null);
      }}
    />
  );
};

const renderitzarCampTipusLlista = (
  nomCamp,
  esEditable,
  valor,
  valorsPossibles,
  observadorIntroduccioModificarCamp
) => {
  if (!esEditable) {
    return valorsPossibles.find(valorPossible => valorPossible.id === valor)
      .valor;
  }

  const estilsSelector = {
    selector: styles.observadorLlistatSelector
  };
  const variable = { id: nomCamp, nom: null, valor, valorsPossibles };

  return (
    <VariableLlista
      estils={estilsSelector}
      variable={variable}
      onChangeValorVariable={valor =>
        observadorIntroduccioModificarCamp(nomCamp, valor)}
      allowClear={false}
    />
  );
};

const renderitzarCampTipusData = (
  nomCamp,
  esEditable,
  valor,
  observadorIntroduccioModificarCamp
) => {
  const dataSeleccionadaText = valor;
  const dataSeleccionada = dataSeleccionadaText
    ? convertirTextAMomentUTC(dataSeleccionadaText, MASCARA_YYYYMMDD)
    : null;

  if (!esEditable) {
    return dataSeleccionada
      ? dataSeleccionada.format(MASCARA_DDMMYYYY)
      : TEXT_QUAN_NO_HI_HA_DADA;
  }

  return (
    <DatePicker
      className={styles.observadorFormulariData}
      defaultValue={dataSeleccionada}
      onChange={date => {
        const dataText = date ? date.format(MASCARA_YYYYMMDD) : null;
        observadorIntroduccioModificarCamp(nomCamp, dataText);
      }}
      format={MASCARA_DDMMYYYY}
    />
  );
};

class ObservadorFormulari extends Component {
  state = {
    disableComponents: false
  };

  componentDidMount() {
    const { esEditable, dadesEditades, dadesOriginals } = this.props;

    if (dadesEditades[nomCampActiu] === null) {
      this.props.observadorIntroduccioModificarCamp(
        nomCampActiu,
        OBSERVADOR_ACTIU_VALOR_DEFECTE
      );
    }
    if (dadesEditades[nomCampExpert] === null) {
      this.props.observadorIntroduccioModificarCamp(
        nomCampExpert,
        OBSERVADOR_EXPERT_VALOR_DEFECTE
      );
    }
    if (dadesEditades[nomCampExpert] === null) {
      this.props.observadorIntroduccioModificarCamp(
        nomCampPermis,
        OBSERVADOR_PERMIS_MOSTRAR_NOM_VALOR_DEFECTE
      );
    }

    const esNouObservador =
      dadesOriginals[nomCampMunicipi] === null ? true : false;

    this.props.setTitolApartat(
      esNouObservador
        ? TITOL_CREAR_OBSERVADOR
        : esEditable
          ? TITOL_EDITAR_OBSERVADOR
          : !esEditable ? TITOL_DADES_OBSERVADOR : ""
    );
  }

  disableComponent = value => {
    this.setState({ disableComponents: value });
  };

  renderitzarComponentSegonsTipus(
    nomCamp,
    esEditable,
    tipusCamp,
    valorsPossibles
  ) {
    const { dadesEditades, observadorIntroduccioModificarCamp } = this.props;
    let valor;

    if (
      nomCamp === nomCampDataAlta ||
      nomCamp === nomCampDataBaixa ||
      nomCamp === nomCampMotiuBaixa
    ) {
      valor =
        dadesEditades &&
        dadesEditades.historic &&
        dadesEditades.historic.length > 0
          ? dadesEditades.historic[dadesEditades.historic.length - 1][
              nomCamp.substring(nomCamp.indexOf("-") + 1)
            ]
          : null;
    } else {
      valor =
        dadesEditades && nomCamp in dadesEditades
          ? dadesEditades[nomCamp]
          : null;
    }
    switch (tipusCamp) {
      case "text": {
        return renderitzarCampTipusText(
          nomCamp,
          esEditable,
          valor,
          observadorIntroduccioModificarCamp
        );
      }

      case "boolean": {
        return renderitzarCampTipusText(
          nomCamp,
          esEditable,
          modificarValorBooleanPerTextSiNo(valor),
          observadorIntroduccioModificarCamp
        );
      }

      case "llista": {
        return renderitzarCampTipusLlista(
          nomCamp,
          esEditable,
          valor,
          valorsPossibles,
          observadorIntroduccioModificarCamp
        );
      }

      case "data": {
        if (nomCamp.includes("data")) {
          valor =
            dadesEditades &&
            dadesEditades.historic &&
            dadesEditades.historic.length > 0
              ? dadesEditades.historic[dadesEditades.historic.length - 1][
                  nomCamp.substring(nomCamp.indexOf("-") + 1)
                ]
              : null;
        }
        return renderitzarCampTipusData(
          nomCamp,
          esEditable,
          valor,
          observadorIntroduccioModificarCamp
        );
      }

      default:
        return null;
    }
  }

  renderitzarComponentBoolean(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "boolean");
  }

  renderitzarComponentText(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "text");
  }

  renderitzarComponentData(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "data");
  }

  renderitzarCampMunicipi() {
    const {
      dadesEditades,
      esEditable,
      municipis,
      observadorIntroduccioModificarCamp
    } = this.props;
    const { Option } = Select;
    const codiMunicipiSeleccionat =
      dadesEditades && dadesEditades[nomCampMunicipi] !== null
        ? dadesEditades[nomCampMunicipi]
        : "";

    if (!esEditable) {
      return dadesEditades ? dadesEditades.municipi : "";
    }

    if (!municipis || !Array.isArray(municipis)) {
      return "";
    }

    const llistaMunicipiSeleccionat = municipis.filter(municipi => {
      return municipi.ineMunicipi === codiMunicipiSeleccionat;
    });

    const nomMunicipiSeleccionat =
      llistaMunicipiSeleccionat && llistaMunicipiSeleccionat.length > 0
        ? llistaMunicipiSeleccionat[0].nomMunicipi
        : "";

    const valor =
      codiMunicipiSeleccionat && nomMunicipiSeleccionat
        ? `${nomMunicipiSeleccionat}#&${codiMunicipiSeleccionat}`
        : "";
    const idCamp = `id-${nomCampMunicipi}`;

    return (
      <Select
        showSearch
        placeholder="Selecciona una municipi..."
        style={{ width: "100%", maxHeight: 100 }}
        id={idCamp}
        onChange={valorSeleccionat => {
          const ineMunicipi = valorSeleccionat.substr(
            valorSeleccionat.indexOf("#&") + 2
          );
          observadorIntroduccioModificarCamp(
            nomCampMunicipi,
            String(ineMunicipi)
          );
        }}
        value={valor ? valor : ""}
      >
        {municipis.map(municipi => {
          return (
            <Option
              key={municipi.ineMunicipi}
              value={`${municipi.nomMunicipi}#&${municipi.ineMunicipi}`}
            >
              {municipi.nomMunicipi}
            </Option>
          );
        })}
      </Select>
    );
  }

  renderitzarCampComarca() {
    const { dadesEditades, municipis, esEditable } = this.props;

    if (!esEditable) {
      return dadesEditades ? dadesEditades.comarca : null;
    }
    if (!dadesEditades || dadesEditades[nomCampMunicipi] === null) {
      return null;
    }

    const codiINEMunicipiSeleccionat = dadesEditades[nomCampMunicipi];

    if (!codiINEMunicipiSeleccionat) {
      return TEXT_QUAN_NO_HI_HA_DADA;
    }

    const municipiSeleccionat =
      municipis && Array.isArray(municipis)
        ? municipis.filter(
            municipi => municipi.ineMunicipi === codiINEMunicipiSeleccionat
          )
        : null;

    const nomComarcaSeleccionada =
      municipiSeleccionat &&
      Array.isArray(municipiSeleccionat) &&
      municipiSeleccionat[0].nomComarca
        ? municipiSeleccionat[0].nomComarca
        : TEXT_QUAN_NO_HI_HA_DADA;
    return nomComarcaSeleccionada;
  }

  renderitzarCampRol() {
    const {
      dadesEditades,
      esEditable,
      rols,
      observadorIntroduccioModificarCamp
    } = this.props;
    const { Option } = Select;
    const rolSeleccionat =
      dadesEditades && dadesEditades[nomCampUsuariRol] !== null
        ? dadesEditades[nomCampUsuariRol]
        : "";

    if (!esEditable) {
      const rolNom = rols.filter(rol => {
        return rol.id === dadesEditades.usuariRol;
      })[0];

      return rolNom ? rolNom.nom : "";
    }

    if (!rols || !Array.isArray(rols)) {
      return null;
    }

    const idCamp = `id-${nomCampUsuariRol}`;
    const valor = `${rolSeleccionat}`;

    return (
      <Select
        style={{ width: "100%", maxHeight: 100 }}
        id={idCamp}
        onChange={valorSeleccionat =>
          observadorIntroduccioModificarCamp(
            nomCampUsuariRol,
            parseInt(valorSeleccionat)
          )}
        value={valor}
      >
        {rols.map(rol => {
          return (
            <Option key={rol.id} value={`${rol.id}`}>
              {rol.nom}
            </Option>
          );
        })}
      </Select>
    );
  }

  renderitzarCampOpcio(camp, valorDefecte) {
    const {
      dadesEditades,
      esEditable,
      observadorIntroduccioModificarCamp
    } = this.props;

    if (!esEditable) {
      return <div>{this.renderitzarComponentBoolean(camp, esEditable)}</div>;
    }

    const valorSeleccionat =
      dadesEditades[camp] !== null ? dadesEditades[camp] : valorDefecte;

    const idCamp = `id-${camp}`;

    return (
      <Switch
        id={idCamp}
        defaultChecked={valorSeleccionat}
        aria-labelledby={camp}
        onChange={valorSeleccionat =>
          observadorIntroduccioModificarCamp(camp, valorSeleccionat)}
      />
    );
  }

  renderitzarArbre(indretsIndividusFenofases) {
    const { TreeNode } = Tree;

    if (indretsIndividusFenofases.length === 0) {
      return (
        <div className={styles.observadorNoIndividus}>
          Aquest observador no té individus associats
        </div>
      );
    }

    return (
      <Tree
        selectable={false}
        showLine={true}
        showIcon={true}
        defaultExpandAll={false}
      >
        {indretsIndividusFenofases.map(indret => {
          const clauIndret = `0-${indret.id}`;
          const individus = indret.individus;
          return (
            <TreeNode
              icon={<Icon type="environment" />}
              title={indret.nom}
              key={clauIndret}
            >
              {individus.map(individu => {
                const clauIndividu = `${clauIndret}-${individu.id}`;
                const fenofases = individu.fenofases;
                return (
                  <TreeNode
                    icon={<Icon type="star" theme="filled" />}
                    title={individu.nom}
                    key={clauIndividu}
                  >
                    {fenofases.map(fenofase => {
                      const clauFenofase = `${clauIndret}-${clauIndividu}-${fenofase.codi}`;
                      return (
                        <TreeNode title={fenofase.nom} key={clauFenofase} />
                      );
                    })}
                  </TreeNode>
                );
              })}
            </TreeNode>
          );
        })}
      </Tree>
    );
  }

  renderitzarComponentImatge(fotoUrl, esEditable, dadesEditades) {
    if (esEditable) {
      const nomObservador = `${dadesEditades.nom
        ? dadesEditades.nom
        : ""} ${dadesEditades.cognom1
        ? dadesEditades.cognom1
        : ""} ${dadesEditades.cognom2 ? dadesEditades.cognom2 : ""}`;
      return (
        <ObservadorFormulariFoto
          fotoUrl={fotoUrl}
          nomObservador={nomObservador}
          onDisableComponent={this.disableComponent}
        />
      );
    } else {
      return (
        <div>
          <Avatar size={120} src={fotoUrl} alt="Fotografia de l'observador" />
        </div>
      );
    }
  }

  renderitzarSeccioDadesContacte() {
    const {
      esEditable,
      dadesEditades,
      dadesOriginals,
      errors,
      mostrarErrors,
      indretsIndividusFenofases
    } = this.props;

    if (!esEditable && dadesOriginals[nomCampMunicipi] === null) {
      return null;
    }

    const esNouObservador =
      dadesOriginals[nomCampMunicipi] === null ? true : false;

    const mostrarDataBaixa =
      dadesEditades &&
      dadesEditades.historic &&
      dadesEditades.historic.length > 0
        ? dadesEditades.historic[dadesEditades.historic.length - 1][
            nomCampDataBaixa
          ]
        : false;

    let llistaErrors = [];
    if (mostrarErrors) {
      llistaErrors = errors;
    }

    const errorCampNom = llistaErrors[nomCampNomObservador];
    const errorCampCognom1 = llistaErrors[nomCampCognom1Observador];
    const errorCampCognom2 = llistaErrors[nomCampCognom2Observador];
    const errorCampTelefon = llistaErrors[nomCampTelefon];
    const errorCampEmail = llistaErrors[nomCampEmail];
    const errorCampCodiINEMunicipi = llistaErrors[nomCampMunicipi];
    const errorCampCarrer = llistaErrors[nomCampCarrer];
    const errorCampCodiPostal = llistaErrors[nomCampCodiPostal];
    const errorCampUsuariNom = llistaErrors[nomCampUsuariNom];
    const errorCampNivell = llistaErrors[nomCampExpert];
    const errorCampPermis = llistaErrors[nomCampPermis];
    const errorCampActiu = llistaErrors[nomCampActiu];
    const errorCampRol = llistaErrors[nomCampUsuariRol];
    const errorCampDataAlta = llistaErrors[nomCampDataAlta];
    const errorCampDataBaixa = llistaErrors[nomCampDataBaixa];
    const errorCampMotiuBaixa = llistaErrors[nomCampMotiuBaixa];
    const fotoUrl =
      dadesEditades && dadesEditades.foto ? dadesEditades.foto.url : null;

    return (
      <div className={styles.observadorFormulariGrid}>
        <div className={styles.observadorImg}>
          {this.renderitzarComponentImatge(fotoUrl, esEditable, dadesEditades)}
        </div>
        <div className={styles.observadorUsuari}>
          <div className={styles.label} id={nomCampUsuariNom}>
            Usuari:
          </div>
          <div>
            {this.renderitzarComponentText(
              nomCampUsuariNom,
              esEditable && esNouObservador
            )}
          </div>
          {renderitzarError(errorCampUsuariNom)}
        </div>

        <div className={styles.observadorRol}>
          <div className={styles.label} id={nomCampUsuariRol}>
            Rol:
          </div>
          <div>{this.renderitzarCampRol()}</div>
          {renderitzarError(errorCampRol)}
        </div>

        <div className={styles.observadorActiu}>
          <div className={styles.label} id={nomCampActiu}>
            Actiu:
          </div>
          <div>
            {this.renderitzarCampOpcio(
              nomCampActiu,
              OBSERVADOR_ACTIU_VALOR_DEFECTE
            )}
          </div>
          {renderitzarError(errorCampActiu)}
        </div>

        <div className={styles.observadorExpert}>
          <div className={styles.label} id={nomCampExpert}>
            Expert:
          </div>
          <div>
            {this.renderitzarCampOpcio(
              nomCampExpert,
              OBSERVADOR_EXPERT_VALOR_DEFECTE
            )}
          </div>
          {renderitzarError(errorCampNivell)}
        </div>

        <div className={styles.observadorMostrarNom}>
          <div className={styles.label} id={nomCampPermis}>
            Mostrar nom:
          </div>
          <div>
            {this.renderitzarCampOpcio(
              nomCampPermis,
              OBSERVADOR_PERMIS_MOSTRAR_NOM_VALOR_DEFECTE
            )}
          </div>
          {renderitzarError(errorCampPermis)}
        </div>

        <div className={styles.observadorNom}>
          <div className={styles.label} id={nomCampNomObservador}>
            Nom:
          </div>
          <div>
            {this.renderitzarComponentText(nomCampNomObservador, esEditable)}
          </div>
          {renderitzarError(errorCampNom)}
        </div>

        <div className={styles.observadorCognom1}>
          <div className={styles.label} id={nomCampCognom1Observador}>
            Cognom 1:
          </div>
          <div>
            {this.renderitzarComponentText(
              nomCampCognom1Observador,
              esEditable
            )}
          </div>
          {renderitzarError(errorCampCognom1)}
        </div>

        <div className={styles.observadorCognom2}>
          <div className={styles.label} id={nomCampCognom2Observador}>
            Cognom 2:
          </div>
          <div>
            {this.renderitzarComponentText(
              nomCampCognom2Observador,
              esEditable
            )}
          </div>

          {renderitzarError(errorCampCognom2)}
        </div>

        <div className={styles.observadorDates}>
          <div className={styles.label}>{"Data d'alta:"}</div>
          <div>
            {this.renderitzarComponentData(
              "dataAlta",
              esEditable && esNouObservador
            )}
          </div>
          {renderitzarError(errorCampDataAlta)}

          {mostrarDataBaixa ? (
            <div className={styles.label} id={nomCampDataBaixa}>
              Data de baixa:
            </div>
          ) : null}

          {mostrarDataBaixa ? (
            <div>
              {this.renderitzarComponentData(
                nomCampDataBaixa,
                esEditable && esNouObservador
              )}
            </div>
          ) : null}
          {mostrarDataBaixa ? renderitzarError(errorCampDataBaixa) : null}

          {mostrarDataBaixa ? (
            <div className={styles.label} id={nomCampMotiuBaixa}>
              Motiu de baixa:
            </div>
          ) : null}
          {mostrarDataBaixa ? (
            <div>
              {this.renderitzarComponentText(
                nomCampMotiuBaixa,
                esEditable && esNouObservador
              )}
            </div>
          ) : null}
          {mostrarDataBaixa ? renderitzarError(errorCampMotiuBaixa) : null}
        </div>

        <div className={styles.observadorEmail}>
          <div className={styles.label} id={nomCampEmail}>
            Correu electrònic:
          </div>
          <div>{this.renderitzarComponentText(nomCampEmail, esEditable)}</div>
          {renderitzarError(errorCampEmail)}
        </div>

        <div className={styles.observadorTel}>
          <div className={styles.label} id={nomCampTelefon}>
            Telèfon:
          </div>

          <div>{this.renderitzarComponentText(nomCampTelefon, esEditable)}</div>
          {renderitzarError(errorCampTelefon)}
        </div>

        <div className={styles.observadorCarrer}>
          <div className={styles.label} id={nomCampCarrer}>
            Carrer:
          </div>
          <div>{this.renderitzarComponentText(nomCampCarrer, esEditable)}</div>

          {renderitzarError(errorCampCarrer)}
        </div>

        <div className={styles.observadorAdreca}>
          <div className={styles.label} id={nomCampNumeroCarrer}>
            Número:
          </div>
          <div>
            {this.renderitzarComponentText(nomCampNumeroCarrer, esEditable)}
          </div>
          <div
            id={nomCampPis}
            className={styles.label + " " + styles.observadorPis}
          >
            Pis:
          </div>
          <div>{this.renderitzarComponentText(nomCampPis, esEditable)}</div>
          <div
            id={nomCampPorta}
            className={styles.label + " " + styles.observadorPorta}
          >
            Porta:
          </div>
          <div>{this.renderitzarComponentText(nomCampPorta, esEditable)}</div>
        </div>

        <div className={styles.observadorCP}>
          <div className={styles.label} id={nomCampCodiPostal}>
            Codi postal:
          </div>
          <div>
            {this.renderitzarComponentText(nomCampCodiPostal, esEditable)}
          </div>
          {renderitzarError(errorCampCodiPostal)}
        </div>
        <div className={styles.observadorMunicipi}>
          <div className={styles.label} id={nomCampNomMunicipi}>
            Municipi:
          </div>
          <div>{this.renderitzarCampMunicipi()}</div>
          {renderitzarError(errorCampCodiINEMunicipi)}
        </div>

        <div className={styles.observadorComarca}>
          <div className={styles.label} id={nomCampNomComarca}>
            Comarca:
          </div>
          <div>{this.renderitzarCampComarca()}</div>
        </div>

        <div className={styles.observadorIndividus}>
          <div className={styles.label}>Què observa?</div>
          <div className={styles.observadorIndividusTree}>
            {this.renderitzarArbre(indretsIndividusFenofases)}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.camp}>{this.renderitzarSeccioDadesContacte()}</div>
    );
  }
}

ObservadorFormulari.propTypes = {
  esEditable: PropTypes.bool,
  history: PropTypes.object,
  observadorIntroduccioModificarCamp: PropTypes.func,
  municipis: PropTypes.array,
  dadesEditades: PropTypes.object,
  dadesOriginals: PropTypes.object,
  rols: PropTypes.array,
  errors: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    municipis: getMunicipis(state),
    dadesEditades: getDadesEditades(state),
    dadesOriginals: getDadesOriginals(state),
    rols: getRols(state),
    errors: obtenirErrorsDadesObservador(state.observadors.formulari.editades),
    mostrarErrors: getMostrarErrors(state),
    indretsIndividusFenofases: getIndretsIndividusFenofasesObservador(state)
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  observadorIntroduccioModificarCamp
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ObservadorFormulari
);
